<template>
  <div aria-hidden="true" ref="sendInvitationModal" tabindex="-1" class="modal hidden fade" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title mt-0">{{$t('account_settings.send_invitation.new_user')}}</h5>
          <button aria-label="Close" data-dismiss="modal" type="button" class="close">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div v-if="unverifiedUser" class="unverified-info">
            <p>
              {{ $t('verify.info_send_1') }} <strong> {{ $t('verify.info_send_2') }}  </strong> {{ $t('verify.info_invite_3') }}
              <br>
              {{ $t('verify.info_part_2') }}
            </p>
          </div>
          <form @submit.prevent="submitForm($event)" ref="sendInvitationForm">
            <input name="utf8" type="hidden" value="✓">
            <div class="form-group">
              <label class="col-form-label">
                <strong data-toggle="tooltip" title="" data-original-title="The user needs an email in order to receive the invitation">*</strong>
                {{$t('account_settings.send_invitation.email')}}
              </label>
              <input required="required" type="email" name="user[email]" id="user_email_invitation" class="form-control" ref="userEmail">
            </div>
            <div class="form-group">
              <span class="mandatory">{{$t('account_settings.send_invitation.mandatory')}}</span>
              <input type="submit" :disabled="unverifiedUser" name="commit" :value="$t('account_settings.send_invitation.invite')" data-disable-with="Invite" class="btn btn-primary float-right">
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    mounted() {
      $(this.$refs.sendInvitationModal).on('hidden.bs.modal', (e) => {
        $(this.$refs.sendInvitationForm)[0].reset()
      })
    },
    methods: {
      openModal() {
        $(this.$refs.sendInvitationModal).modal('show')
        this.$nextTick(() => {
          setTimeout(() => {
            $(this.$refs.userEmail).focus()
          }, 500)
        })
      },
      submitForm(event) {
          this.store.createInvitation(new FormData(this.$refs.sendInvitationForm)).then(() => {
            this.store.sendMetrics({name: 'create_invitation', params: this.$route.params, path: this.$route.fullPath})
            this.store.getCurrentOrg().then(() => {
              this.$toastr.success(this.$t('account_settings.send_invitation.success'))

              this.closeModal()
            })
          })
      },
      closeModal() {
        $(this.$refs.sendInvitationModal).modal('hide')
      },
    },
  }
</script>
